module.exports = __webpack_public_path__ + "media/assets/img/flags/da-DK-f8655f1f24c7ee6e7f3812df40abd058.png";